import React from 'react';
import './listPage.css';

/**
 * «Δεν βρέθηκαν κλήσεις» + μία γραμμή (+ μία ενέργεια). Χωρίς μεγάλο εικονίδιο: το πολύ ένα λεπτό lucide
 * 20px (π.χ. icon={PhoneOff}) — ως 14/10 οι σελίδες είχαν εικονίδιο 48px σε κύκλο, που ο ιδιοκτήτης δεν θέλει.
 */

export interface EmptyStateProps {
  title: React.ReactNode;
  hint?: React.ReactNode;
  action?: React.ReactNode;
  /** Προαιρετικό λεπτό εικονίδιο lucide (το component, όχι στοιχείο): ζωγραφίζεται 20px. */
  icon?: React.ElementType;
  testId?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ title, hint, action, icon: Icon, testId = 'empty-state' }) => (
  <div className="lp-empty" data-testid={testId}>
    {Icon && <Icon className="lp-empty-ico" aria-hidden="true" strokeWidth={1.75} />}
    <p className="lp-empty-title">{title}</p>
    {hint && <p className="lp-empty-hint">{hint}</p>}
    {action && <div className="lp-empty-action">{action}</div>}
  </div>
);

export default EmptyState;
